import { FC, useEffect } from 'react';
import { TableWithSearch } from 'modules/ui/pageWithTable';
import { Loader } from 'modules/ui';
import { FormButtons } from 'modules/ui/form';
import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { LeasingCalculatorSelectors } from 'modules/leasingCalculator/redux';
import { useToastContainer } from 'modules/layout/toastContainer';
import { ToastType } from 'modules/ui/toast';
import { useTranslation } from 'react-i18next';
import { resetProductSelectionData } from 'modules/leasingCalculator/redux/slice';
import { usePremadeProductsActions } from './usePremadeProductsActions';
import { LeasingCalculatorSharedFormProps } from '../../common/LeasingCalculatorData';

export const LeasingCalculatorProductSelectionData: FC<
  LeasingCalculatorSharedFormProps
> = ({ defaultValues, onPreviousStep }) => {
  const { addToast } = useToastContainer();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const loadingPremadeProducts = useAppSelector(
    LeasingCalculatorSelectors.selectPremadeProductsLoading,
  );

  const selectedPremadeProductError = useAppSelector(
    LeasingCalculatorSelectors.selectProductSelectionDataError,
  );
  const leasingOfferDetailsLoading = useAppSelector(
    LeasingCalculatorSelectors.selectProductSelectionDataLoading,
  );

  useEffect(() => {
    if (selectedPremadeProductError) {
      addToast({
        type: ToastType.Urgent,
        title: t('leasingCalculator.stepErrorTitle'),
        text: t('leasingCalculator.stepErrorMessage'),
      });
      dispatch(resetProductSelectionData());
    }
  }, [addToast, dispatch, selectedPremadeProductError, t]);

  return (
    <Loader active={loadingPremadeProducts || leasingOfferDetailsLoading}>
      <TableWithSearch
        showSearch
        formData={defaultValues}
        useFormActions={usePremadeProductsActions}
      />
      <FormButtons onPreviousStep={onPreviousStep} hideSubmitButton />
    </Loader>
  );
};
